import { API_BASE } from "../utils";
import { ApiError, requestJson } from "./request";
import { COLLECTION_SYNC_MODES } from "../utils/collection";

/** @typedef {{sync_collection_with_discogs: "ask" | "always" | "never", dark_mode: boolean}} CollectionSettingsDto */
function validateSettings({ data, status, requestId }) {
  if (
    status !== 200 ||
    !COLLECTION_SYNC_MODES.includes(data?.sync_collection_with_discogs) ||
    typeof data?.dark_mode !== "boolean"
  ) {
    throw new ApiError(
      "Invalid collection settings response. Reload settings before continuing.",
      status,
      requestId,
    );
  }
  return data;
}

/** @returns {Promise<CollectionSettingsDto>} */
export async function getCollectionSettings(signal) {
  return validateSettings(
    await requestJson(`${API_BASE}/settings/`, { signal }),
  );
}

/** @returns {Promise<CollectionSettingsDto>} */
export async function saveCollectionSettings(syncPreference) {
  if (!COLLECTION_SYNC_MODES.includes(syncPreference))
    throw new Error("Choose whether to sync collection changes with Discogs.");
  return saveUserSettings({ sync_collection_with_discogs: syncPreference });
}

export async function saveUserSettings(changes) {
  const fields = Object.keys(changes);
  if (
    !fields.length ||
    fields.some(
      (key) => !["sync_collection_with_discogs", "dark_mode"].includes(key),
    )
  )
    throw new Error("Unknown user setting");
  if ("dark_mode" in changes && typeof changes.dark_mode !== "boolean")
    throw new Error("Dark mode must be a boolean");
  if (
    "sync_collection_with_discogs" in changes &&
    !COLLECTION_SYNC_MODES.includes(changes.sync_collection_with_discogs)
  )
    throw new Error("Choose whether to sync collection changes with Discogs.");
  return validateSettings(
    await requestJson(`${API_BASE}/settings/`, {
      method: "PATCH",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(changes),
    }),
  );
}
